import { Component, Input, type OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MultilineTextCellComponent } from './multiline-text-cell.component';

@Component({
    selector: 'app-numbered-multiline-text-cell',
    templateUrl: './multiline-text-cell.component.html',
    styleUrls: ['./multiline-text-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NumberedMultilineTextCellComponent extends MultilineTextCellComponent {
  private originalList: string[] = [];

  @Input() set dataContext(val: string[]) {
    this.originalList = val;

    let updatedList = val?.map((tx, i) => i + 1 + ') ' + tx);
    super.dataContext = updatedList;
  }

  get dataContext(): string[] {
    return super.dataContext;
  }
}